export const dispatchEventSendContact = data => {
  const { contactForm: { listingId } } = data

  global.dispatchEvent(new CustomEvent('send-contact', { detail: { listingId } }))
}
